import React from "react";
import {Accordion} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCircle, faBatteryFull, faBatteryThreeQuarters, faBatteryHalf, faBatteryQuarter, faBatteryEmpty, faMobile
} from "@fortawesome/free-solid-svg-icons";
import Badge from "react-bootstrap/Badge";
import MateCard from "../Cards/MateCard";
import {truncateFirmwareVersion, formatTargetName} from "../../../../../lib/ui/badgeUtils";

function MatesList({mates, matesData, matesLoading, matesError}) {
    if (!mates || mates.length === 0) {
        return null;
    }

    // Get battery icon and color based on battery level
    const getBatteryInfo = (battery) => {
        if (battery === undefined) return null;

        let icon, color;
        if (battery > 75) {
            icon = faBatteryFull;
            color = "success";
        } else if (battery > 50) {
            icon = faBatteryThreeQuarters;
            color = "success";
        } else if (battery > 25) {
            icon = faBatteryHalf;
            color = "warning";
        } else if (battery > 10) {
            icon = faBatteryQuarter;
            color = "danger";
        } else {
            icon = faBatteryEmpty;
            color = "danger";
        }

        return {icon, color};
    };

    return (<Accordion defaultActiveKey="0" className="mb-2">
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <div>
                            <FontAwesomeIcon icon={faMobile} className="me-2"/>
                            Mates
                        </div>
                        <Badge bg="dark">
                            {mates.length}
                        </Badge>
                    </div>
                </Accordion.Header>
                <Accordion.Body className="p-2">
                            {/* Nested accordion for individual mates - collapsed by default */}
                            <Accordion>
                                {mates.map((mate, idx) => {
                                    const mateData = matesData[mate.bond_id];
                                    const isLoading = matesLoading[mate.bond_id];
                                    const error = matesError[mate.bond_id];
                                    const sysVersion = mateData?.sys?.version || {};
                                    const mateInfo = mateData?.sidekicks?.[mate.bond_id] || {};
                                    const batteryInfo = getBatteryInfo(mateInfo.battery);
                                    // const batteryInfo = getBatteryInfo(mateInfo.battery);

                                    return (<Accordion.Item eventKey={mate.bond_id} key={mate.bond_id}>
                                            <Accordion.Header>
                                                <div className="d-flex flex-wrap align-items-center w-100" style={{gap: '0.5rem'}}>
                                                    {/* Left-aligned items */}
                                                    <div className="d-flex align-items-center">
                                                        <h5 className="mb-0">{batteryInfo && (
                                                            <Badge bg={batteryInfo.color} className="me-2">
                                                                <FontAwesomeIcon icon={batteryInfo.icon} className="me-1"/>{mateInfo.battery}%
                                                            </Badge>) || <FontAwesomeIcon
                                                            icon={faCircle}
                                                            className="me-2 secondary"
                                                        />}
                                                            <span className="fw-bold"> {mate.bond_id}</span></h5>
                                                    </div>

                                                    {/* Right-aligned items - wrapped together */}
                                                    <div className="d-flex align-items-center ms-auto" style={{gap: '0.25rem'}}>
                                                        {sysVersion.make && sysVersion.model && (<Badge bg="dark">
                                                                {sysVersion.make} {sysVersion.model}
                                                            </Badge>)}
                                                        {sysVersion.fw_ver && (<Badge bg="secondary" title={sysVersion.fw_ver}>
                                                                {truncateFirmwareVersion(sysVersion.fw_ver)}
                                                            </Badge>)}
                                                        {sysVersion.target && (<Badge bg="info">
                                                                {formatTargetName(sysVersion.target)}
                                                            </Badge>)}
                                                    </div>
                                                </div>
                                            </Accordion.Header>
                                            <Accordion.Body className="p-2">
                                                {isLoading ? (<div className="text-center p-5">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>) : error ? (<div className="alert alert-danger">
                                                        Error loading mate {mate.bond_id}: {error}
                                                    </div>) : mateData ? (<MateCard mateData={mateData}/>) : (
                                                    <div className="text-center text-muted p-3">
                                                        No data available for {mate.bond_id}
                                                    </div>)}
                                            </Accordion.Body>
                                        </Accordion.Item>);
                                })}
                            </Accordion>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>);
}

export default MatesList;
